import { useStore } from '@/stores';
import { FEATURE_STATUS } from '@/shared/constants/featureFlags';
import { FeatureFlags } from '@/services/solgari-api/interfaces/feature-flags.interface';

export const useFeatureFlag = (featureType: string) => {
  const {
    settingsStore: { featureFlags },
  } = useStore();

  if (!featureFlags) {
    return {
      isEnabled: false,
      status: undefined,
    };
  }

  const featureFlag: FeatureFlags | undefined = featureFlags.find(
    (flag: FeatureFlags) => flag.featureType === featureType,
  );

  const status = featureFlag?.featureStatus?.trim().toLowerCase();
  const isEnabled = status === FEATURE_STATUS.ENABLED;

  return {
    isEnabled,
    status,
  };
};
